module.exports = __webpack_public_path__ + "img/balance-report-preview.8e6960d9.png";